type TItem = {
    id: number,
    count?: number,
    duration?: number,
}

type TEquipData = {
    ids: number[],
    duration: number[],
    costType: number[],
}

/**
 * Подготавливает список оборудования для заявки на подключение
 */
export const transformEquipmentForRequest = (equipItems: TItem[]) => {
    return equipItems.reduce((acc: TEquipData, equip) => {
        acc.ids.push(equip.id);
        acc.duration.push(equip.duration || 0);
        acc.costType.push(equip.duration ? 5 : 1);
        return acc;
    }, {
        ids: [],
        duration: [],
        costType: [],
    });
};
